<template>
  <div style="margin-top:18px">
    <!--    <div class="point"  >-->
    <!--      <div>-->
    <!--        <div-->
    <!--          :class="{ 'active-scroll': code == index }"-->
    <!--          @click="handlerClickId(item)"-->
    <!--          v-for="(item, index) in pointList"-->
    <!--          :key="item.code"-->
    <!--          style="cursor: pointer"-->
    <!--        >-->
    <!--          {{ item.name }}-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="m-wrapper zbpmbj" style="border-radius:0px;">
          <div style="position: relative;">
      <div class="titleBox">
        <span class="bigTitleInfo">Index Ranking</span>
        <span class="chenge-dir">Statistics in {{ rankLut.year }}<br>The following data is for reference only</span>
      </div>
    </div>
      <div class="center" style="border-top:1px solid #E6E6E6;">
        <div class="left">
          <div style="align-items: flex-end;position: relative;">
            <div class="chart-title1">GDP of Province/Municipality where FTZ is located</div>
            <div class="chart-title2">Unit：billion CNY</div>
          </div>

          <div style="height: 307px">
            <ChartBar
              :title="'GDP'"
              :unit="'billion CNY'"
              :width="'100%'"
              :height="'308px'"
              :id="'cysss'"
              :keyCount="'gdp'"
              :keyName="'ftzName'"
              :option="gdpList"
              :data-zoom-flag="true"
              :barColor="'#71DBC6'"
              :barBorderColor="'#71DBC6'"
            />
          </div>
        </div>
        <div class="right">
          <div style="align-items: flex-end;position: relative;">
            <div class="chart-title1">Tax Revenue Ranking of FTZ</div>
            <div class="chart-title2">Unit：billion CNY</div>
          </div>
          <div style="height: 307px">
            <ChartBar
              :title="'Tax Revenue Ranking of FTZ'"
              :unit="'billion CNY'"
              :width="'100%'"
              :height="'308px'"
              :id="'cy1'"
              :keyName="'ftzName'"
              :keyCount="'tax'"
              :option="taxList"
              :data-zoom-flag="true"
              :barColor="'#FDAE59'"
              :barBorderColor="'#FDAE59'"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="splitLine"></div>
    <!-- <FtaBottomDateInfo :date="rankLut" :info="'Data statistic circle of index ranking comparison'"></FtaBottomDateInfo> -->
    <!-- <div
      class="mt10 m-wrapper zbdb"
      style="margin-top:0px;border-radius:0px;padding-bottom:25px;"
    >
      <div style="position: relative;">
        <div class="titleBox">
          <span class="bigTitleInfo">Index Comparison</span>
          <span class="chenge-dir">Statistics in {{ jingjitime.year }}<br>The following data is for reference only</span>
        </div>
      </div>
      <div class="splitLine"></div> -->
      <!--      <FtaHeader :title="'指标对比'" />-->
      <!-- <div>
        <div class="filter-wrapper" style="padding:0 0 0 35px;">
          <div class="filter-content">
            <div class="item">
              <div class="info">
                <span class="star">*</span>
                Data is from respective FTZ websites：
              </div>
            </div>
            <div class="item" :style="{ width: width }">
              <div class="item"> -->
              <!-- <div class="inner-wrapper">
                <div
                  style="width: 100px;font-size: 14px;color: #000A12;font-weight:400;"
                  class="label"
                >
                  Free Trade Zone
                </div>
                <div class="form">
                  <el-select
                    filterable
                    v-model="form.ftzId"
                    style="width: 100%"
                    popper-class="select-down"
                    multiple
                    size="small"
                    :multiple-limit="multiple"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="item in ftzIdList"
                      :key="item.id"
                      :label="item.val"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="filter-confirm">
            <div class="confirm-button" @click="getQueryList">Go</div>
          </div>
        </div>
      </div>
      <div class="trend_broken_line_top">
        <div class="jjyxfxBox">
          <div class="jjyxfxTitleBox1" title="Tax revenue growth trend of FTZ">
            <span class="jjyxfxTitle">Tax revenue growth trend of FTZ</span>
          </div>
          <div class="jjyxfxUnit">Unit: billion CNY</div>
          <TargetContrastLine
            :unit="'billion CNY'"
            :width="'100%'"
            :height="'280px'"
            :id="'chart100'"
            :legendDataVal="'ftzName'"
            :list="'trendList'"
            :option="alllist.taxList"
          />
        </div>
        <div class="jjyxfxBox">
          <div
            class="jjyxfxTitleBox1"
            title="New foreign companies growth trend of FTZ"
          >
            <span class="jjyxfxTitle"
              >New foreign companies growth trend of FTZ</span
            >
          </div>
          <div class="jjyxfxUnit"></div>
          <TargetContrastLine
            :unit="'Companies'"
            :width="'100%'"
            :height="'280px'"
            :id="'chart101'"
            :legendDataVal="'ftzName'"
            :list="'trendList'"
            :option="alllist.newEntCountList"
          />
        </div>
      </div>
      <div class="trend_broken_line_down">
        <div class="jjyxfxBox">
          <div class="jjyxfxTitleBox1" title="Growth trend of total FDI in FTZ">
            <span class="jjyxfxTitle">Growth trend of total FDI in FTZ</span>
          </div>
          <div class="jjyxfxUnit">Unit: billion USD</div>
          <TargetContrastLine
            :unit="'billion USD'"
            :width="'100%'"
            :height="'280px'"
            :id="'jck'"
            :legendDataVal="'ftzName'"
            :list="'trendList'"
            :option="alllist.fgnInvestList"
          />
        </div>
        <div class="jjyxfxBox">
          <div
            class="jjyxfxTitleBox1"
            title="Growth trend of total import and export of FTZ"
          >
            <span class="jjyxfxTitle"
              >Growth trend of total import and export of FTZ</span
            >
          </div>
          <div class="jjyxfxUnit">Unit：billion CNY</div>
          <TargetContrastLine
            :unit="'billion CNY'"
            :width="'100%'"
            :height="'280px'"
            :id="'chart103'"
            :legendDataVal="'ftzName'"
            :list="'trendList'"
            :option="alllist.tmxList"
          />
        </div> -->
      <!-- </div> -->
      <!--      <div style="margin: 0 35px">
              <FtaTable
                ref="FtaTable"
                :tableData="tableData"
                :column="column"
                height="325"
                :scrollStar="scrollStar"
                :diaLogShow="false"
              />
            </div>-->
    <!-- </div> -->
    <!-- <FtaBottomDateInfo :date="jingjitime" :info="'Economic growth comparison data until'"></FtaBottomDateInfo> -->
    <!-- <div class="spaceline"></div> -->
    <target-contrast-search-new/>
    <div class="spaceline"></div>
  </div>
</template>

<script>
import FtaHeader from "../component/FtaHeader";
import request from "../../../ftaUtils/http";
import baseUrl from "../../../ftaUtils/baseUrl";
import FtaTable from "../component/FtaTable";
import ChartBar from "../component/ChartBar";
import FtaTitle from "../component/FtaTitle";
import FtaBottomDateInfo from "../component/FtaBottomDateInfo";
import TargetContrastLine from "./TargetContrastLine";
import { getCookieKey } from "../../../ftaUtils/util";
// import TargetContrastSearch from "./TargetContrastSearch.vue"
import TargetContrastSearchNew from "./TargetContrastSearchNew.vue";

export default {
  name: "TargetContrast",
  components: {
    FtaHeader,
    FtaTable,
    ChartBar,
    FtaTitle,
    FtaBottomDateInfo,
    TargetContrastLine,
    // TargetContrastSearch,
    TargetContrastSearchNew
  },
  data() {
    return {
      width: "480px",
      alllist: [],
      multiple: 5,
      rankLut: {},
      jingjitime: {},
      scrollStar: true,
      gdpList: [],
      taxList: [],
      form: {
        indexName: [],
        ftzId: ["0100"]
      },
      indexNameList: [],
      ftzIdList: [],
      tableData: [],
      column: [
        {
          width: "80px",
          prop: "nums",
          label: "ID",
          color: "#3447FF",
          align: "center"
        },
        { prop: "indexName", label: "Index name", align: "center" },
        { prop: "ftzName", label: "free trade zone", align: "center" },
        {
          prop: "ftzRank",
          label: "Index name",
          align: "center",
          color: "#3447FF"
        },
        { prop: "num", label: "Number", align: "center", color: "#3447FF" }
      ],
      code: 0,
      ponitShow: false,
      pointList: [
        { name: "Index comparison", code: 0, id: "#compare" },
        { name: "Index Comparison", code: 1, id: "#trend" }
      ]
    };
  },
  methods: {
    handlerClickId(item) {
      this.$emit("scrollId", item.id);
      // this.code = item.code;
    },
    getQueryIndexName() {
      request("get", `${baseUrl.base_1}/indexCompare/queryIndexName`).then(
        res => {
          this.indexNameList = res.data;
          this.indexNameList.unshift({ val: "All", id: "" });
        }
      );
    },
    getQueryFta() {
      request("get", `${baseUrl.base_1}/indexCompare/queryFta`).then(res => {
        this.ftzIdList = res.data;
        // this.ftzIdList.unshift({val: '全部', id: ''})
        // this.getQueryList()
      });
    },
    getQueryBy() {
      request("get", `${baseUrl.base_1}/indexCompare/queryBy`).then(res => {
        this.gdpList = res.data.gdpList;
        this.taxList = res.data.taxList;
        this.rankLut = { year: res.data.rankLut.year };
        this.jingjitime = res.data.rankLut;
      });
    },
    getQueryList() {
      let ftzIdStr = this.form.ftzId.join(",") || "0100";
      // url /indexCompare/queryCompared/
      request("get", `${baseUrl.base_1}/indexCompare/queryTrend/`, {
        ftzId: ftzIdStr
      }).then(res => {
        this.alllist = res.data;
        // this.alllist.fgnInvestList = []
        // res.data.fgnInvestList.forEach(element => {
        //   this.alllist.fgnInvestList.push({
        //     ftzId: element.ftzId,
        //     ftzName: element.ftzName,
        //     name:[],
        //     val:[]
        //   })
        // });
        // this.tableData = res.data
        // this.tableData.forEach((item, index) => {
        //   item.nums = index + 1
        // })
      });
    }
    // doScroll (ref, flag) {
    //   const table = this.$refs[ref].$refs.table
    //   const divData = table.bodyWrapper
    //   divData.onmouseenter = () => {
    //     this[flag] = false
    //   }
    //   divData.onmouseleave = () => {
    //     this[flag] = true
    //   }
    // },
  },
  watch: {
    "form.ftzId"() {
      if (this.form.ftzId.length <= 3) {
        this.width = "500px";
      } else if (this.form.ftzId.length === 5) {
        this.$message.warning("5 at most");
        this.width = "750px";
      } else {
        this.width = "670px";
      }
    }
  },
  created() {
    const TS02b1f2d3 = getCookieKey("TS02b1f2d3");
    this.$store.commit("ftaToken", TS02b1f2d3);

    // this.getQueryIndexName()

    this.getQueryBy();
  },
  mounted() {
    this.$eventBus.$on("changeData", data => {
      this.ponitShow = data.ponitShow;
      this.code = data.code;
    });

    this.getQueryFta();
    this.getQueryList();
    // this.doScroll('FtaTable', 'scrollStar')
  }
};
</script>

<style src="../fta.css"  scoped></style>
<style lang="less"  src="./TargetContrast.less"  scoped></style>
<style scoped lang="less">
.point {
  position: fixed;
  right: 5%;
  top: 29.5%;
  background: #ffffff;
  border: 1px solid #c9e4ff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
  border-radius: 0 0 5px 5px;
  width: 123px;
  z-index: 1000;
  padding: 17px 13px 6px;
  &::before {
    content: "";
    background-image: linear-gradient(180deg, #51c9ff 0%, #89e5ff 100%);
    border-radius: 5px 5px 0 0;
    width: 123px;
    height: 8px;
    position: absolute;
    top: -8px;
    left: -1px;
  }
  > div {
    border-left: 1px solid #d7d7d7;
    > div {
      opacity: 0.3;
      // font-family: SourceHanSansCN-Regular;
      font-size: 12px;
      color: #000000;
      letter-spacing: -0.24px;
      font-weight: 400;
      text-indent: 9px;
      overflow: hidden;
      line-height: 16px;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 90px;
      margin-bottom: 13px;
    }
    .active-scroll {
      // font-family: SourceHanSansCN-Regular;
      font-size: 12px;
      color: #208eff;
      letter-spacing: -0.24px;
      font-weight: 400;
      opacity: 1;
      border-left: 1px solid #2291fe;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 90px;
    }
  }
}
/deep/ .el-select__tags {
  flex-wrap: nowrap !important;
}
// /deep/ .el-select, .el-select--small{
//   display: inline;
// }
</style>
